import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import ProjectRegisterPage from "./components/project-register/ProjectRegisterPage";
import { ProtectedRoute } from "./route/ProtectedRoute";
import { AuthProvider } from "./store/AuthContext";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/app/" replace />} />
          <Route path="/app" element={<Navigate to="/app/" replace />} />
          <Route
            path="/app/"
            element={
              <ProtectedRoute>
                <ProjectRegisterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/app/*"
            element={
              <ProtectedRoute>
                <ProjectRegisterPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/app/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
